import { render, staticRenderFns } from "./Externos.vue?vue&type=template&id=0382481c&"
import script from "./Externos.vue?vue&type=script&lang=js&"
export * from "./Externos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports